// removed by extract-text-webpack-plugin
module.exports = {"stepTitle":"qempo_Order_stepTitle-NCM7qUz","lightBlue":"qempo_Order_lightBlue-d324xcK","orange":"qempo_Order_orange-1Ex8gV-","stepSubtitle":"qempo_Order_stepSubtitle-bOXtLdg","orderMainWrap":"qempo_Order_orderMainWrap-2ALY8Bp","hidden":"qempo_Order_hidden-S10J_eP","loadingWrap":"qempo_Order_loadingWrap-1oXPJ2y","stateTrackerWrap":"qempo_Order_stateTrackerWrap-11T0RGx"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/components/Order.scss
// module id = 1956
// module chunks = 0